<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('/markets/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('config.add_market') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameMarketSelected"
            :visible.sync="modals.read"
            width="51%"
            top="2%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('config.market') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('config.ports') }}:</strong>
                        </h6>
                        <span v-for="port in rowData.ports" :key="port.name">
                          <el-tag type="info">
                            {{ port.name }}
                          </el-tag>
                          <br />
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(business, index) in rowData.businesses"
                          :key="index"
                        >
                          <el-tag type="info">{{ business.name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-muted">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="80"
                :align="'center'"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="100"
                prop="props.businesses"
                :label="$t('common_words.associated_companies')"
                :align="'center'"
                :sortable="true"
                :resizable="false"
              >
                <template slot-scope="scope">
                  <el-badge
                    class="custom-el-badge__content item"
                    v-if="scope.row.businesses.length > 0"
                    :hidden="scope.row.businesses.length == 1 ? true : false"
                    :value="200"
                    :max="scope.row.businesses.length - 1"
                  >
                    <el-button plain type="info" size="small">
                      {{ scope.row.businesses[0].name }}</el-button
                    >
                  </el-badge>
                </template>
              </el-table-column>
              <el-table-column
                v-if="isShow() || isUpdate() || isDelete()"
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6">
          <div class="text-left" v-if="isExcel()">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination as LPagination } from 'src/components/index';
import SweetAlert from 'src/class/Alerts';
import configTable from './marketTable';
import { Axios } from 'src/class/Axios.js';
import moment from 'moment';
import Fuse from 'fuse.js';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinMenu from 'src/util/mixinMenu';
import i18n from '../../../../i18n';

export default {
  components: {
    LPagination,
  },

  computed: { ...configTable().Search },

  data() {
    return {
      marketForm: {
        name: null,
        ports: [],
        businesses: [],
      },
      modelValidations: {
        nombre: {
          required: true,
        },
      },
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        delete: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
      nameMarketSelected: i18n.t('config.market'),
      map: null,
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.nameMarketSelected =
        i18n.t('config.market') + ':' + ' ' + this.rowData.name;
      this.modals.read = true;
    },

    handleEdit(index, row) {
      this.editForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.editForm));
      this.$router.push({
        path: '/markets/edit',
      });
    },

    handleDelete(index, row) {
      this.marketForm = row;
      SweetAlert.delete(
        i18n.t('config.the_market') + ' ' + this.marketForm.name
      ).then((result) => {
        if (result.value) this.deleteMarket();
      });
    },

    deleteMarket() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.marketForm.route = 'markets';
        Axios.destroyMaster(this.marketForm)
          .then((response) => this.modifyTable(2, this.marketForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'markets/pdf';
      data.name_file = `${i18n.t('config.markets')}.pdf`;
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'markets/excel';
      data.name_file = `${i18n.t('config.markets')}.xlsx`;
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('markets')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((column) => {
              return column.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('markets');
  },

  destroyed() {
    this.deselectedItemOnMenu('markets');
  },
};
</script>
<style></style>
